module.exports = __webpack_public_path__ + "img/profile.f719afaf.svg";